<div class="access-denied" id="div_access-denied_58c3f527">
  <img
    title="Warning"
    src="../../../../assets/icons/warning.svg"
    alt="Warning"
    aria-label="Warning Icon"
    id="img_846bb335"
  />
  <h1 title="TRM h1 title" aria-label="Access Denied" id="h1_82a9600e">
    ACCESS DENIED
  </h1>
  <p id="p_ea101525">
    Please get in touch with your sales representative if you have questions or
    feel this message was received in error.
  </p>
</div>
